import {
    CATEGORY_UPDATE_SUCCESS,
    CATEGORY_UPDATE_START,
    CATEGORY_UPDATE_ERROR
} from '../../../constants/index';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { updateSubCategoryStatusMutation as mutation, getAllSubCategory } from '../../../lib/graphql';

export const updateSubCategoryStatus = (id, currentPage, fieldName, fieldValue) => {
    return async (dispatch, getState, { client }) => {

        try {

            dispatch({
                type: CATEGORY_UPDATE_START
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    fieldName,
                    fieldValue
                },
                refetchQueries: [{ query: getAllSubCategory, variables: { currentPage, searchList: '' } }]
            });

            if (data?.updateSubCategoryStatus?.status == 200) {
                dispatch({
                    type: CATEGORY_UPDATE_SUCCESS
                });
                showToaster({ messageId: 'statusSubCatSuccess', requestContent: { id }, toasterType: 'success' });
            } else {
                dispatch({
                    type: CATEGORY_UPDATE_ERROR
                });

                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateSubCategoryStatus?.errorMessage }, toasterType: 'error' });
            }
        } catch (err) {
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
            dispatch({
                type: CATEGORY_UPDATE_ERROR
            });
        }
    }
};